import { inputClass } from "@/components/manufacturing/manufacturingSurfaceClasses";
import { LABOR_PAYS_BY, type LaborPaysBy } from "@/lib/manufacturing/laborPayQuantity";

export function ManufacturingLaborPaysBySelect({
  value,
  disabled,
  onChange,
}: {
  value: LaborPaysBy | "";
  disabled?: boolean;
  onChange: (next: LaborPaysBy | "") => void;
}) {
  return (
    <select
      className={inputClass}
      value={value}
      disabled={disabled}
      onChange={(e) => onChange((e.target.value || "") as LaborPaysBy | "")}
    >
      <option value="">Choose Pays by…</option>
      {LABOR_PAYS_BY.map((row) => (
        <option key={row.id} value={row.id}>
          {row.label}
        </option>
      ))}
    </select>
  );
}
